import { Injectable } from '@angular/core';

import { ConfigParserService } from '../shared/services/config-parser.service';

// Adopted heavily from '@angular/service-worker' source code:
// https://github.com/angular/angular/blob/7cabaa0ae745dfbbad664b71da70eec89c17c744/packages/service-worker/src/module.ts

// For details about Service Worker registration and scope:
// https://developer.mozilla.org/en-US/docs/Web/API/ServiceWorkerContainer/register
// https://developer.mozilla.org/en-US/docs/Web/API/ServiceWorkerRegistration/scope

interface ServiceWorkerConfig {
    readonly diskPreloadEnabled: boolean;
    readonly enabled: boolean;
    readonly pilotFlights: ReadonlyArray<string>;
    readonly serviceWorkerAllowedFlights: ReadonlyArray<string>;
    readonly scope: string;
    readonly scriptUrl: string;
}

@Injectable({
    providedIn: 'root'
})
export class ServiceWorkerConfigService {
    public config: ServiceWorkerConfig;

    constructor(
        configParserService: ConfigParserService
    ) {
        this.config = configParserService.parse<ServiceWorkerConfig>('serviceWorkerConfig') || {
            diskPreloadEnabled: false,
            enabled: false,
            pilotFlights: [],
            serviceWorkerAllowedFlights: [],
            scope: '',
            scriptUrl: ''
        };
    }
}
